// extracted by mini-css-extract-plugin
export var container = "_5e-1";
export var cornerButtonContainer = "_5e-6";
export var disabled = "_5e-2";
export var dragActive = "_5e-3";
export var fileContainer = "_5e-5";
export var hiddenInput = "_5e-4";
export var widthContainer = "_5e-0";